<template>
    <div>
        <preferences-modal />
        <div class="full-width d-flex align-center flex-nowrap py-2 px-5 bg-grey-lighten-3 overflow-hidden">
            <div>
                <v-icon>mdi-account-search</v-icon>
                {{ $t('search_and_booking_for') }}
                {{ `${person.prefix || ''} ${person.firstName || ''} ${person.lastName || ''}` }}
            </div>
            <v-btn
                size="small"
                icon="mdi-information-outline"
                variant="text"
                color="primary"
                data-cy="show-modal"
                @click="showPreferencesModal"
            />
        </div>
    </div>
</template>

<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'
    import {EventBus, SHOW_PREFERENCES_MODAL} from '@/utils/event-bus'
    import PreferencesModal from '@/components/modals/PreferencesModal.vue'

    @Component({
        components: {
            PreferencesModal,
        },
    })
    export class TravelPreferences extends Vue {
        showPreferencesModal(): void {
            EventBus.$emit(SHOW_PREFERENCES_MODAL, {
                title: this.$t('travel_preferences'),
                text: authStore.person?.travelPreferences || this.$t('not_available'),
            })
        }

        get person() {
            return authStore.person
        }
    }
    export default TravelPreferences
</script>
